import styled from '@emotion/styled';
import { menuStyle as popupMenuStyle } from './InterfaceLanguageMenuStyle';
import { lightGrey, white } from './colors';
import arrowDown from '../assets/images/dropdown.svg';

const _fontSize = 14;
const _itemHeight = 22;

export const menuStyle = {
  ...popupMenuStyle,

  itemHeight: _itemHeight,

  MenuButton: styled.div(() => {
    let style = {
      position: 'relative',
      cursor: 'pointer',
      width: '100%',
      height: '100%',
      backgroundColor: white,
      border: '1px solid' + lightGrey,
      borderRadius: '5px',
      padding: '4px 8px'
    };
    return style;
  }),

  MenuButtonLabel: styled(popupMenuStyle.MenuButtonLabel)((props) => {
    let style = {
      fontSize: _fontSize,
      fontWeight: '400',
      left: 18,
      right: 'auto',
      top: 5,
      textAlign: 'right'
    };
    return style;
  }),

  MenuButtonArrow: styled(popupMenuStyle.MenuButtonArrow)((props) => {
    let style = {
      backgroundImage: 'url(' + arrowDown + ')',
      left: 'auto',
      right: 12,
      top: 6,
      position: 'absolute'
    };
    return style;
  }),

  MenuList: styled(popupMenuStyle.MenuList)((props) => {
    let style = {
      left: 'auto',
      right: -20
    };
    return style;
  }),

  MenuItem: styled(popupMenuStyle.MenuItem)((props) => {
    let style = {
      fontSize: _fontSize,
      paddingTop: 2,
      fontWeight: '400'
    };
    return style;
  })
};



// WEBPACK FOOTER //
// ./src/styles/InterfaceLanguageMenuDropdownStyle.js